import { Handle, Position } from '@xyflow/react'
import '@xyflow/react/dist/style.css'
import styles from "./nodes.module.css"

const AiConditional = ({ data, selected, dragging }) => {
    return (
        <div className={`${styles.node} ${selected ? styles.selected : ''} ${dragging ? styles.dragging : ''}`}>
            <Handle type="target" position={Position.Top} />
            <span>{data.label}</span>
            <Handle type="source" position={Position.Bottom} id="true" style={{ left: '30%', background: 'green' }} />
            <Handle type="source" position={Position.Bottom} id="false" style={{ left: '70%', background: 'red' }} />
        </div>
    )
}

export default AiConditional